export default "__VITE_ASSET__CEYSZnnB__"